import React from 'react';
import { FormattedAddress } from '@css-xp/base';
import { CommerceAddress } from '@css-xp/graphtypes/src/generated-types-new';
import { SoldToAddressDetailsLink } from './sold-to-address-details-link';

export interface SoldToAddressProps {
  shipTo?: CommerceAddress | null;
  txaId?: string;
  className?: string;
  hasLineBreak?: boolean;
  shouldDisableLink?: boolean;
}

export const SoldToAddress = ({
  txaId,
  shipTo,
  className = 'line-clamp',
  hasLineBreak,
  shouldDisableLink,
}: SoldToAddressProps) => {
  if (shipTo?.id) {
    return (
      <SoldToAddressDetailsLink txaId={txaId} shipToId={shipTo.id} shouldDisableLink={shouldDisableLink}>
        <div className={className}>
          <FormattedAddress
            addressLine1={shipTo?.addressLine1}
            addressLine2={shipTo?.addressLine2}
            city={shipTo?.city}
            country={shipTo?.country}
            postcode={shipTo?.postcode}
            state={shipTo?.state}
            hasLineBreak={hasLineBreak}
          />
        </div>
      </SoldToAddressDetailsLink>
    );
  } else {
    return (
      <div className={className}>
        <p>Same as billing address</p>
      </div>
    );
  }
};
